import { render } from "./Form-Lowongan.vue?vue&type=template&id=68bfd264"
import script from "./Form-Lowongan.vue?vue&type=script&lang=js"
export * from "./Form-Lowongan.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__